import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Anchor } from 'lucide-react';

const ClosedPage = () => {
  return (
    <>
      <Helmet>
        <title>SOGNUDIMARE — Fermeture définitive</title>
        <meta
          name="description"
          content="L'aventure SOGNUDIMARE touche à sa fin. Merci à tous pour ces belles saisons en mer."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <main
        className="min-h-screen w-full flex items-center justify-center relative overflow-hidden bg-[#0A1E37]"
        data-testid="closed-page"
      >
        {/* Ambient background */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(42,157,143,0.18),_transparent_55%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_rgba(196,114,79,0.14),_transparent_60%)]" />
          <div
            className="absolute inset-0 opacity-[0.06]"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cpath d='M30 0 L60 30 L30 60 L0 30 Z' fill='none' stroke='white' stroke-width='0.5'/%3E%3C/svg%3E\")",
            }}
          />
        </div>

        <div className="relative z-10 max-w-2xl mx-auto px-6 py-16 text-center">
          {/* Logo mark */}
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/5 border border-white/15 backdrop-blur-sm mb-10">
            <Anchor className="h-9 w-9 text-[#C4956A]" strokeWidth={1.4} />
          </div>

          {/* Brand */}
          <p
            className="text-[#C4956A] text-xs sm:text-sm font-semibold uppercase tracking-[0.4em] mb-5"
            data-testid="closed-brand"
          >
            Sognudimare
          </p>

          {/* Headline */}
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-white leading-tight tracking-tight mb-6">
            Fin d'une <span className="italic text-[#2A9D8F]">belle aventure</span>
          </h1>

          {/* Separator */}
          <div className="mx-auto w-12 h-px bg-white/25 mb-8" />

          {/* Body */}
          <div className="space-y-5 text-white/80 text-base sm:text-lg leading-relaxed">
            <p>
              Après plusieurs années de navigation, de rencontres et de couchers de soleil
              partagés, l'aventure <strong className="text-white font-semibold">SOGNUDIMARE</strong> touche
              à sa fin.
            </p>
            <p>
              Les voiles sont rangées, le bord est désormais silencieux. Les réservations,
              nouvelles demandes et croisières ne sont plus assurées.
            </p>
            <p>
              Nous vous prions sincèrement de nous excuser pour la gêne occasionnée et vous
              remercions pour la confiance accordée au fil de ces belles saisons en mer.
            </p>
          </div>

          {/* Signature */}
          <div className="mt-14 pt-8 border-t border-white/10">
            <p className="text-white/50 text-xs sm:text-sm tracking-wider uppercase">
              L'équipage Sognudimare
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default ClosedPage;
